<template>
    <div class="page-content margin-bottom-60">
        <div class="center-text own-title margin-bottom-10">
            Talent Profiling Guide
        </div>
        <div class="content margin-top-30 margin-bottom-30">
            <div class="talent-result-info margin-bottom-10 text-left">
                Name : <span class="talent-result-info-extra">{{name}}</span> 
            </div>
            <div class="talent-result-info margin-bottom-10 text-left">
                Phone : <span class="talent-result-info-extra">{{phone}}</span> 
            </div>
            <div class="talent-result-info margin-bottom-10 text-left">
                Email : <span class="talent-result-info-extra">{{email}}</span> 
            </div>
            <div class="talent-result-info margin-bottom-10 text-left">
                Introducer Name :  <input class="introducer-input" name="introducer_name" type="text" placeholder="">
            </div>
        </div>
        <div class="content">
            <table class="table-style">
                <tr>
                    <td class="bold" rowspan="2" style="width:30%">I. INTERESTS</td>
                    <td>{{setG1}}</td>
                    <td>{{setE1}}</td>
                    <td>{{setN1}}</td>
                    <td>{{setL1}}</td>
                    <td>{{setT1}}</td>
                    <td>{{setP1}}</td>
                </tr>
                <tr class="bold">
                    <td>G</td>
                    <td>E</td>
                    <td>N</td>
                    <td>L</td>
                    <td>T</td>
                    <td>P</td>
                </tr>
                <tr>
                    <td class="bold" rowspan="2">II. CAPABILITY</td>
                    <td>{{setG2}}</td>
                    <td>{{setE2}}</td>
                    <td>{{setN2}}</td>
                    <td>{{setL2}}</td>
                    <td>{{setT2}}</td>
                    <td>{{setP2}}</td>
                </tr>
                <tr class="bold">
                    <td>G</td>
                    <td>E</td>
                    <td>N</td>
                    <td>L</td>
                    <td>T</td>
                    <td>P</td>
                </tr>
                <tr>
                    <td class="bold" rowspan="2">III. PROFESSION</td>
                    <td>{{setG3}}</td>
                    <td>{{setE3}}</td>
                    <td>{{setN3}}</td>
                    <td>{{setL3}}</td>
                    <td>{{setT3}}</td>
                    <td>{{setP3}}</td>
                </tr>
                <tr class="bold">
                    <td>G</td>
                    <td>E</td>
                    <td>N</td>
                    <td>L</td>
                    <td>T</td>
                    <td>P</td>
                </tr>
                <tr>
                    <td class="bold" rowspan="2">IV. SELF APPRAISAL</td>
                    <td>{{setG4}}</td>
                    <td>{{setE4}}</td>
                    <td>{{setN4}}</td>
                    <td>{{setL4}}</td>
                    <td>{{setT4}}</td>
                    <td>{{setP4}}</td>
                </tr>
                <tr class="bold">
                    <td>G</td>
                    <td>E</td>
                    <td>N</td>
                    <td>L</td>
                    <td>T</td>
                    <td>P</td>
                </tr>
                <tr>
                    <td class="bold" rowspan="2">TOTAL</td>
                    <td class="redbold">{{setG}}</td>
                    <td class="redbold">{{setE}}</td>
                    <td class="redbold">{{setN}}</td>
                    <td class="redbold">{{setL}}</td>
                    <td class="redbold">{{setT}}</td>
                    <td class="redbold">{{setP}}</td>
                </tr>
                <tr class="bold">
                    <td>G</td>
                    <td>E</td>
                    <td>N</td>
                    <td>L</td>
                    <td>T</td>
                    <td>P</td>
                </tr>
            </table>
            <div class="clear"></div>
        </div>
        <div class="content">
            <div class="talent-result-new-info talent-result-info">
                <div class="title-new-info">Your Biz Code is: </div>
                <div class="margin-bottom-10">
                    <span>{{result1}}</span>
                    <span>{{result2}}</span>
                    <span>{{result3}}</span>
                </div>
            </div>
        </div>
        <div v-for="order in neworders" :key="order.order">
            <div class="content" :class="hide && (order.order==4||order.order==5||order.order==6)?'talent-hide':''">
                <div class="talent-result-category talent-category text-left">{{order.set}}</div>
                <div class="talent-result-description margin-bottom-30">
                    <div class="talent-category-title">{{order.title}}</div>
                    <div class="talent-category-description">{{order.description}}</div>
                    <div class="talent-category-description">{{order.sample}}</div>
                </div>
            </div>
            <div class="clear"></div>
        </div>
            <div class="content" :class="hideButton?'talent-hide':''">
                <a @click="showall()" class="talent-show-button">{{show_all_text}}</a>
            </div>  
        <div class="content">
            <a class="generali-button-red margin-bottom-10" @click="reset()">
                {{calculate_again_text}}
            </a>
            <div class="talent-result-note">
                *{{snapshot_text}}
            </div>
        </div>
    </div>
</template>
<style scoped>
.talent-result-info {
    color: #7C7B7B;
    font-size: 16px;
}
.talent-result-info-extra {
    color: #7C7B7B !important;
}
.talent-result-code {
    background : #c1210c;
    height: 39px;
    color : #fff;
    font-size: 24px;
    padding: 8px 0;
}
.talent-result-category {
    width: 10%; 
    float: left;
}
.talent-result-description{
    width: 90%; 
    float: right;
}
/* .talent-category {
    font-size: 14px;
    color: #FFC461;
} */
.talent-category-title {
    font-size: 14px;
    color: #7C7B7B;
    line-height: normal;
    text-align: left;
}
.talent-category-description{
    font-size: 10px;
    color: #7C7B7B;
    line-height: normal;
    text-align: left;
}
.talent-show-button {
    font-size: 13px;
    color: #fff;
    text-decoration: underline;
}
.talent-result-note {
    font-size: 10px;
    color: #7A7B7A;
}
.talent-hide {
    display: none;
}
</style>
<script>
export default {
    name: "Result",
    data() {
        return {
            name: 'user',
            email: 'example@email.com',
            phone: '010xxxxxxx',
            orders: [{
                'language': 'en',
                'show_all':'Show All',
                'calculate_again':'Calculate again',
                'snapshot':'Screenshot this page for record purpose',
                'items': [{
                    'set': 'G',
                    'order': 1,
                    'title': 'Realistic',
                    'description': 'Hands-on, tangible result, repair',
                    'sample': 'E.g. Athlete, Chef, Technician'
                },{
                    'set': 'E',
                    'order': 2,
                    'title': 'Conventional',
                    'description': 'Like harmony, system and order, set ways of doing things, disciplined, organized',
                    'sample': 'E.g. Administrator, Auditors'
                },{
                    'set': 'N',
                    'order': 3,
                    'title': 'Artistic',
                    'description': 'Creative, different ‘taste/style',
                    'sample': 'E.g. Dramatist & Dancer, Designers'
                },{
                    'set': 'L',
                    'order': 4,
                    'title': 'Social',
                    'description': 'People - centered, sensitive & accomodating, helps people, relationships count',
                    'sample': 'E.g. Tour guide, Counselor, Nursing, Teaching, Salesperson'
                },{
                    'set': 'T',
                    'order': 5,
                    'title': 'Investigative',
                    'description': 'Asks “Why/Why not”, thinks & analyze',
                    'sample': 'E.g. R&D Personnel, Mathematician'
                },{
                    'set': 'P',
                    'order': 6,
                    'title': 'Enterprising',
                    'description': 'Aim to achieve, risk taking, goal-centred. pecuniary interest',
                    'sample': 'E.g. Entreprenuer, Import/Exporter, Salesman'
                }]
            },{
                'language': 'cn',
                'show_all':'显示全部',
                'calculate_again':'重新演算',
                'snapshot':'"Screenshot" 储存档案记录',
                'items': [{
                    "set": "G",
                    "order": 1,
                    "title": "实际",
                    "description": "亲力亲为，实际的成果，维修",
                    "sample": "举例： 运动员， 厨师， 技术人员"
                },{
                    "set": "E",
                    "order": 2,
                    "title": "传统",
                    "description": "爱好和平，系统与规律，有方案地执行任务，有纪律，有条理",
                    "sample": "举例： 行政员， 审计师"
                },{
                    "set": "N",
                    "order": 3,
                    "title": "艺术",
                    "description": "创新，异常‘品味/风格’",
                    "sample": "举例： 艺人&舞者， 设计家"
                },{
                    "set": "L",
                    "order": 4,
                    "title": "社交",
                    "description": "以人为本，顾及他人感受&随和，乐于助人",
                    "sample": "举例： 导游， 辅导员， 医护人员， 老师， 销售员"
                },{
                    "set": "T",
                    "order": 5,
                    "title": "研究",
                    "description": "提问“为什么/为什么不”，思考&分析",
                    "sample": "举例： 研究与开发人员， 数学家"
                },{
                    "set": "P",
                    "order": 6,
                    "title": "积极",
                    "description": "积极于实现目标，敢于承担风险，目标导向，在乎金钱利益",
                    "sample": "举例： 企业家，进口/出口商， 销售员"
                }]
            },{
                'language': 'bm',
                'show_all':'Tunjukkan Semua',
                'calculate_again':'Kira Semula',
                'snapshot':'"Screenshot" dan simpan untuk rujukan',
                'items': [{
                    "set": "G",
                    "order": 1,
                    "title": "Realistik",
                    "description": "Praktikal, hasil yang ketara, memperbaiki",
                    "sample": "Contohnya: Atlet, Chef, Juruteknik"
                },{
                    "set": "E",
                    "order": 2,
                    "title": "Konvensional",
                    "description": "Harmoni, sistem dan peraturan, penetapan kerja, berdisiplin, perancangan yang teratur",
                    "sample": "Contohnya: Pentadbir, Juru Audit"
                },{
                    "set": "N",
                    "order": 3,
                    "title": "Artistik",
                    "description": "Kreatif, pelbagai 'cara/gaya'",
                    "sample": "Contohnya: Dramatis, Penari, Pereka"
                },{
                    "set": "L",
                    "order": 4,
                    "title": "Social/Masyarakat",
                    "description": "Mengutamakan orang lain, sensitif & bertolak ansur, saling bantu-membantu, mementingkan hubungan",
                    "sample": "Contohnya: Pemandu pelancong, Jururawat, Guru, Jurujual"
                },{
                    "set": "T",
                    "order": 5,
                    "title": "Penyiasatan",
                    "description": 'Biasa tanya "Kenapa/Mengapa tidak", berfikir & menganalisa',
                    "sample": "Contohnya: Kakitangan R&D, Ahli Matematik"
                },{
                    "set": "P",
                    "order": 6,
                    "title": "Keusahawanan",
                    "description": "Berazam untuk berjaya, mengambil risiko, bermatlamat, kepentingan kewangan",
                    "sample": "Contohnya: Usahawan, Pengimport / Pengeksport, Jurujual"
                }]
            }],
            language: '',
            conclusion: {},
            result: '',
            result1: '',
            result2: '',
            result3: '',
            hide: true,
            hideButton: false,
            chosenIndex: 0,
            setG:0,
            setG1:0,
            setG2:0,
            setG3:0,
            setG4:0,
            setE:0,
            setE1:0,
            setE2:0,
            setE3:0,
            setE4:0,
            setN:0,
            setN1:0,
            setN2:0,
            setN3:0,
            setN4:0,
            setL:0,
            setL1:0,
            setL2:0,
            setL3:0,
            setL4:0,
            setT:0,
            setT1:0,
            setT2:0,
            setT3:0,
            setT4:0,
            setP:0,
            setP1:0,
            setP2:0,
            setP3:0,
            setP4:0,
        }
    },
    mounted(){
        if(localStorage.getItem('talent_test')){
            try{
                this.conclusion = JSON.parse(localStorage.getItem('talent_test'))
                this.name = this.conclusion.name
                this.phone = this.conclusion.phone
                this.email = this.conclusion.email
                this.language = this.conclusion.language
                var setG = this.conclusion.g1 + this.conclusion.g2 + this.conclusion.g3 + this.conclusion.g4
                var setE = this.conclusion.e1 + this.conclusion.e2 + this.conclusion.e3 + this.conclusion.e4
                var setN = this.conclusion.n1 + this.conclusion.n2 + this.conclusion.n3 + this.conclusion.n4
                var setL = this.conclusion.l1 + this.conclusion.l2 + this.conclusion.l3 + this.conclusion.l4
                var setT = this.conclusion.t1 + this.conclusion.t2 + this.conclusion.t3 + this.conclusion.t4
                var setP = this.conclusion.p1 + this.conclusion.p2 + this.conclusion.p3 + this.conclusion.p4
                this.setG = this.conclusion.g1 + this.conclusion.g2 + this.conclusion.g3 + this.conclusion.g4
                this.setE = this.conclusion.e1 + this.conclusion.e2 + this.conclusion.e3 + this.conclusion.e4
                this.setN = this.conclusion.n1 + this.conclusion.n2 + this.conclusion.n3 + this.conclusion.n4
                this.setL = this.conclusion.l1 + this.conclusion.l2 + this.conclusion.l3 + this.conclusion.l4
                this.setT = this.conclusion.t1 + this.conclusion.t2 + this.conclusion.t3 + this.conclusion.t4
                this.setP = this.conclusion.p1 + this.conclusion.p2 + this.conclusion.p3 + this.conclusion.p4
                this.setG1 = this.conclusion.g1
                this.setE1 = this.conclusion.e1
                this.setN1 = this.conclusion.n1
                this.setL1 = this.conclusion.l1
                this.setT1 = this.conclusion.t1
                this.setP1 = this.conclusion.p1
                this.setG2 = this.conclusion.g2
                this.setE2 = this.conclusion.e2
                this.setN2 = this.conclusion.n2
                this.setL2 = this.conclusion.l2
                this.setT2 = this.conclusion.t2
                this.setP2 = this.conclusion.p2
                this.setG3 = this.conclusion.g3
                this.setE3 = this.conclusion.e3
                this.setN3 = this.conclusion.n3
                this.setL3 = this.conclusion.l3
                this.setT3 = this.conclusion.t3
                this.setP3 = this.conclusion.p3
                this.setG4 = this.conclusion.g4
                this.setE4 = this.conclusion.e4
                this.setN4 = this.conclusion.n4
                this.setL4 = this.conclusion.l4
                this.setT4 = this.conclusion.t4
                this.setP4 = this.conclusion.p4
                const numbers = [{
                    'set': 'G',
                    'qty': setG
                },{
                    'set': 'E',
                    'qty': setE
                },{
                    'set': 'N',
                    'qty': setN
                },{
                    'set': 'L',
                    'qty': setL
                },{
                    'set': 'T',
                    'qty': setT
                },{
                    'set': 'P',
                    'qty': setP
                }]
                numbers.sort(
                    function(a, b){
                        return b.qty-a.qty
                })
                this.result = numbers[0].set+numbers[1].set+numbers[2].set
                this.result1 = numbers[0].set
                this.result2 = numbers[1].set
                this.result3 = numbers[2].set
                var setG_Order = numbers.findIndex(function(set){return set.set=='G';})+1
                var setE_Order = numbers.findIndex(function(set){return set.set=='E';})+1
                var setN_Order = numbers.findIndex(function(set){return set.set=='N';})+1
                var setL_Order = numbers.findIndex(function(set){return set.set=='L';})+1
                var setT_Order = numbers.findIndex(function(set){return set.set=='T';})+1
                var setP_Order = numbers.findIndex(function(set){return set.set=='P';})+1
                for(var a = 0; a<this.orders.length;a++){
                    if(this.language === this.orders[a].language){
                        this.chosenIndex = a;
                        this.orders[a].items[0].order = setG_Order
                        this.orders[a].items[1].order = setE_Order
                        this.orders[a].items[2].order = setN_Order
                        this.orders[a].items[3].order = setL_Order
                        this.orders[a].items[4].order = setT_Order
                        this.orders[a].items[5].order = setP_Order
                        var show_all=this.orders[a].show_all
                        var snapshot=this.orders[a].snapshot
                        var calculate_again=this.orders[a].calculate_again
                    }
                }
                const sortedActivities = this.orders[this.chosenIndex].items.slice().sort((a, b) => a.order - b.order)
                this.orders[this.chosenIndex].items=sortedActivities;
                this.orders[this.chosenIndex].items.show_all = show_all
                this.orders[this.chosenIndex].items.snapshot = snapshot
                this.orders[this.chosenIndex].items.calculate_again = calculate_again
            }
            catch(e){
                // console.log(e)
                localStorage.removeItem('talent_test')
            }
        }
    },
    methods: {
        reset(){
            localStorage.removeItem('talent_test')
            this.$router.push({path: 'talent-profiling-guide'})
        },
        showall(){
            this.hide = false
            this.hideButton = true
        }
    }, 
    computed:{
        neworders() {
            return this.orders[this.chosenIndex].items 
        },
        show_all_text() {
            return this.orders[this.chosenIndex].items.show_all
        },
        snapshot_text() {
            return this.orders[this.chosenIndex].items.snapshot
        },
        calculate_again_text() {
            return this.orders[this.chosenIndex].items.calculate_again
        },
    },
}
</script>